<template>
  <div :class="classes">
    <slot name="pre-icon" />
    <b-icon :icon="icon" class="ml-1 mr-1" />
    <in-training-mode
      :next="next"
      :area="value.$area"
      v-if="value && value.$isInTrainingMode"
      message="This sensor is currently in training mode"
    />
    {{ labelPrefix }} <b>{{ value.serial }}</b>
    <slot>
      <span v-if="showLinkIcon" class="is-pulled-right mr-3">
        <b-icon
          :icon="linkIcon"
          type="is-link"
          :class="{ pointer: true }"
          @click.native="
            $router.push(getLinkFunction(value));
            $event.preventDefault();
          "
        />
      </span>
    </slot>
    <slot name="end" />
  </div>
</template>

<script>
import iconFor from "../../icons";
import Position from "../../dataClasses/Position";

export default {
  name: "PositionDisplay",
  computed: {
    icon() {
      return iconFor("position");
    },
  },
  props: {
    next: {
      type: String,
      required: false,
    },
    labelPrefix: {
      type: String,
      default: "Sensor",
    },
    classes: {
      type: String,
      default: "",
    },
    value: {
      type: Position,
      required: true,
    },
    showLinkIcon: {
      type: Boolean,
      default: false,
    },
    linkIcon: {
      type: String,
      default: iconFor("update"),
    },
    getLinkFunction: {
      type: Function,
      default: function (pos) {
        return this.$router.match({
          name: "go-to-device",
          params: { serial: pos.serial },
        });
      },
    },
  },
};
</script>

<style scoped>
.inline-block {
  display: inline-block;
}
</style>
